import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';

const ContentTextField: React.FC<TextFieldProps> = ({
	slotProps,
	...props
}) => (
	<TextField
		autoComplete="off"
		slotProps={{
			formHelperText: { role: 'alert' },
			input: {
				sx: { width: '100%' }
			},
			...slotProps
		}}
		size="small"
		sx={{
			display: 'block'
		}}
		variant="outlined"
		{...props}
	/>
);

export default ContentTextField;
